'use strict';

/*
	app 一键快签模块
    created by fanglijuan 2019-04-22
 */
angular.module('appQuickSignModule', [
    'appQuickSignRouterModule',
    'quickSignMymanuscriptModule', // 关联管理-我的稿件
    'quickSignMypushModule', // 关联管理-我的推送
    'quickSignAllmanuscriptModule', // 关联管理-所有稿件
    'quickSignAllpushModule', // 关联管理-所有推送
    'quickSignManuscriptAssociationModule', // 审核关联-稿件关联
    'quickSignPushAssociationModule', // 审核关联-稿件推送
    'quickSignOneClickQuickSignModule', // 一键快签-一键快签
    'quickSignOperationLogModule', // 操作日志
    'quickSignIssueTypeModule', // 签发类型
    'appQuickSignServiceModule', // 公共服务
    'appQuickSignLeftModule', // 左侧导航
    'quickSignOneClickQuickSignDetailListModule', // 一键快签(详情:列表页)
    'manuscriptAssociationModule',
]).controller('editingCenterQuickSignController', ['$scope', 'initSingleSelecet', 'trsHttpService', '$q', '$state', '$timeout', 'globleParamsSet', 'appQuickSignService', 'modalDialog', 'editingCenterService', '$sessionStorage', 'trsspliceString', 'storageListenerService', 'messagePublishService', function ($scope, initSingleSelecet, trsHttpService, $q, $state, $timeout, globleParamsSet, appQuickSignService, modalDialog, editingCenterService, $sessionStorage, trsspliceString, storageListenerService, messagePublishService) {
    initStatus();
    // initData();
    
    /**
     * [initStatus description]初始化状态
     *
     * @return  {[type]}  [return description]
     */
    function initStatus() {
        $scope.keywords = '';
        $scope.params = {
            selectedDocType: 'docType'
        };
        $scope.data = {
            // 过滤问题稿件后的数组
            filterReviseItem: [],
            // 第一次的flag
            firstFlag: false,
            // 可选择的渠道
            trenchJsons: [],
            // 选择的渠道 
            selectedTrench: {},
            docTypeJsons: [{
                name: '全部稿件',
                value: ''
            }, {
                name: '新闻',
                value: '1'
            }, {
                name: '图集',
                value: '2'
            }, {
                name: '视频',
                value: '7'
            }],
            selectedDocType: {},
            // 选择的媒体
            inputMedia: '',
            // 列表上展示的数据
            items: [],
            // 选择的数组
            selectedArray: [],
            copyCurrPage: 1,
            siteid: $state.params.siteid,
            channelid: $state.params.channelid,
            MediaType: '',
            SubmitMediaJson: [],
            listPicRatio: {
                set: {
                    0: '',
                    1: '',
                    2: '',
                },
                practical: {
                    0: '1',
                    1: '1',
                    2: '1',
                },
            },
            focusRatio: {
                set: '',
                practical: '1',
            },
            bigPicRtion: {
                set: '', //  大图只需要设置的值不需要单独实际值，因为大图使用的是列表图的第一张
            },
            specZtPicRtion: {
                set: '', // 窄图
            },
        };
        $scope.page = {
            CURRPAGE: 1,
            PAGESIZE: globleParamsSet.getPageSize(),
        };
        $scope.status = {
        };
    }

    // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
    $scope.requestData = function() {
        initData();
    };

    /**
     * [initData description] 初始化方法
     *
     * @return  {[type]}  [return description]
     */
    function initData() {
        if (!$state.params.channelid) {
            $scope.status.hidePage = true; // 如果栏目参数不足，隐藏改页面
            return;
        }
        $scope.status.hidePage = false;
        getToken().then(function () {
            requestData();
        });
        initDropdown();
        getMediaList();
    }

    /**
     * [requestData description]查询列表
     *
     * @return  {[type]}  [return description]
     */
    function requestData() {
        var params = {
            typeid: 'zyzx',
            serviceid: 'subscript',
            modelid: 'quickSignSearch',
            time: angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                ? $scope.data.fromdate + ',' + $scope.data.untildate
                : '',
            pageSize: $scope.page.PAGESIZE,
            pageNum: $scope.page.CURRPAGE,
            keyword: $scope.keywords,
            wcmChannelId: $state.params.channelid,
            docType: $scope.data.selectedDocType.value,
            tenantid: $sessionStorage.get('curUserInfo').TENANTID,
            user_id: $sessionStorage.get('curUserInfo').ID,
            section: $scope.data.MediaType,
            relationJson: $scope.data.SubmitMediaJson,
            token: $scope.status.token.token,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'POST').then(function (data) {
            var ListItems = data.content;
            $scope.data.items = ListItems;
            $scope.page = data.summary_info;
            $scope.data.indexName = data.summary_info.indexName;
            $scope.data.selectedArray = [];
            storageListenerService.previewPageTurningStorage(data.content, 'ZB_GUID', 'resourceDetail');
            requestListImg(ListItems).then(function (res2) {
                angular.forEach(ListItems, function (value, key) {
                    value.ALLIMG = res2.content[0][value.ZB_GUID];
                });
            });
            requestMark(ListItems).then(function (res) {
                angular.forEach(ListItems, function (value, key) {
                    for (var i = 0; i < res.length; i++) {
                        if (value.ZB_GUID === res[i].GUID) {
                            value.SIGNINFO = res[i].SIGNINFO;
                            value.SIGNFLAG = res[i].SIGNFLAG;
                            value.SIGNUSER = res[i].CRUSERTRUENAME;
                            value.SIGNTIME = res[i].CRTIME;
                        }
                    }
                });
                $scope.data.filterReviseItem = ListItems.filter((item) => !item.SIGNINFO);
            });
        });
    }
    
    /**
     * [requestListImg description]查询列表图示
     *
     * @param   {[type]}  items  [items description]
     *
     * @return  {[type]}         [return description]
     */
    function requestListImg(items) {
        var defer = $q.defer();
        if (!items || items.length < 1) {
            defer.resolve([]);
        } else {
            var params = {
                typeid: 'zyzx',
                serviceid: 'wz',
                modelid: 'getImgList',
                channelName: 'wz',
                guids: trsspliceString.spliceString(items, 'ZB_GUID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                defer.resolve(data);
            });
        }
        return defer.promise;
    }
    
    /**
     * [requestListImg description]查询列表标记
     *
     * @param   {[type]}  items  [items description]
     *
     * @return  {[type]}         [return description]
     */
    function requestMark(items) {
        var defer = $q.defer();
        if (!items || items.length < 1) {
            defer.resolve([]);
        } else {
            var params = {
                serviceid: 'mlf_appquicksign',
                methodname: 'queryQuickSignInfos',
                ChannelId: $state.params.channelid,
                Guids: trsspliceString.spliceString(items, 'ZB_GUID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                if (data.length) {
                    defer.resolve(data);
                } else {
                    defer.reject();
                }
            });
        }
        return defer.promise;
    }

    /**
     * [getToken description] 获取token
     * @return  {[type]}  [return description]
     */
    function getToken() {
        var defer = $q.defer();
        globleParamsSet.getTokenService($sessionStorage.get('curUserInfo').TENANTID).then((data) => {
            $scope.status.token = data;
            defer.resolve();
        });
        return defer.promise;
    }

    
    /**
     * [initDropdown description]初始化下拉框
     *
     * @return  {[type]}  [return description]
     */
    function initDropdown() {
        getTrenchJson();
        // $scope.data.docTypeJsons = initSingleSelecet.appDocType();
        // var docTypeJsons = initSingleSelecet.appDocType();
        // $scope.data.docTypeJsons = [];
        // $scope.data.docTypeJsons = docTypeJsons;
        $scope.data.selectedDocType = $scope.data.docTypeJsons[0];
    }

    /**
     * [getTrenchJson description]获得所有渠道的json
     *
     * @return  {[type]}          [return description]
     */
    function getTrenchJson() {
        var params = {
            serviceid: 'mlf_appquicksign',
            methodname: 'querySelectedChMediaType',
            ChannelId: $state.params.channelid,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
            $scope.data.trenchJsons = data;
            $scope.data.trenchJsons.unshift({
                MEDIATYPE: '',
                MEDIATYPECHNAME: '全部渠道'
            });
            $scope.data.selectedTrench = $scope.data.trenchJsons[0];
        });
    }
    
    /**
     * [getDepartPersonList description]初始化搜索媒体
     *
     * @return  {[type]}  [return description]
     */
    function getMediaList() {
        var defer = $q.defer();
        var params = {
            serviceid: 'mlf_appquicksign',
            methodname: 'querySelectedFromMedia',
            ChannelId: $state.params.channelid,
            MediaType: $scope.data.MediaType,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
            $scope.MediaList = data;
            defer.resolve();
        });
        return defer.promise;
    }
    var promise;
    
    /**
     * [getSuggestions description]根据输入框查询媒体
     *
     * @param   {[type]}  viewValue  [viewValue description]
     *
     * @return  {[type]}             [return description]
     */
    $scope.getSuggestions = function(viewValue) {
        if (promise) {
            $timeout.cancel(promise);
            promise = null;
        }
        promise = $timeout(function() {
            var defer = $q.defer();

            /**
             * [due description]查询媒体
             *
             * @return  {[type]}  [return description]
             */
            function due() {
                if (!$scope.MediaList) {
                    $timeout(() => {
                        due();
                    }, 100);
                } else {
                    if (viewValue !== '' && !angular.isObject(viewValue)) {
                        // $scope.searchParams.Name = viewValue;
                        defer.resolve($scope.MediaList.filter((item) => item.FROMMEDIANAME.includes(viewValue) === true));
                    } else if (viewValue === '') {
                        defer.resolve($scope.MediaList);
                    }
                }
            }

            due();

            return defer.promise;
        }, 100);
        return promise;
    };
    // 监听选择事件返回
    $scope.$on('$typeahead.select', function(event, data){// 监听在子控制器中定义的 sendParent 事件
        $scope.data.inputMedia = data.FROMMEDIANAME;
        $scope.queryDropDown('SubmitMedia', data);
    });

    /**
     * [selectPageNum description]选择分页条数
     * @return {[type]} [description]
     */
    $scope.selectPageNum = function () {
        // $scope.params.CurrPage = $scope.page.CURRPAGE;
        // $scope.params.PageSize = $scope.page.PAGESIZE;
        $scope.status.copyCurrPage = 1;
        requestData();
    };
    
    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.selectDoc = function (item) {
        if ($scope.data.selectedArray.indexOf(item) < 0) {
            $scope.data.selectedArray.push(item);
        } else {
            $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
        }
    };

    /**
     * [selectAll description] 全选
     * @return {[type]} [description]
     */
    $scope.selectAll = function () {
        // $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.items.length ? [] : [].concat($scope.data.items);
        $scope.data.selectedArray =
                    $scope.data.selectedArray.length === $scope.data.filterReviseItem.length ? [] : [].concat($scope.data.filterReviseItem);
    };
    
    /**
     * [queryDropDown description]根据下拉条件查询列表
     *
     * @param   {[type]}  type   [type description]下拉条件
     * @param   {[type]}  value  [value description]下拉值
     *
     * @return  {[type]}         [return description]
     */
    $scope.queryDropDown = function (type, value) {
        if (type === 'trench') {
            $scope.data.MediaType = value || '';
            $scope.data.inputMedia = '';
            $scope.data.SubmitMediaJson = [];
            getMediaList().then(function () {
                $scope.getSuggestions('');
            });
        }
        if (type === 'SubmitMedia') {
        
            $scope.data.SubmitMediaJson = [];
            $scope.data.SubmitMediaJson = value ? JSON.stringify([value]) : [];
        }
        requestData();
    };
    
    /**
     * [pageChanged description] 分页
     * @return {[type]} [description]
     */
    $scope.pageChanged = function () {
        // $scope.params.CurrPage = $scope.page.CURRPAGE;
        $scope.data.copyCurrPage = $scope.page.CURRPAGE;
        requestData();
    };

    /**
     * [jumpToPage description] 跳转到指定页面
     * @return {[type]} [description]
     */
    $scope.jumpToPage = function () {
        if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
            $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
        }
        // $scope.params.CurrPage = $scope.data.copyCurrPage;
        $scope.page.CURRPAGE = $scope.data.copyCurrPage;
        requestData();
    };
    
    /**
     * [setListStyle description]给当前元素设置列表样式
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.setListStyle = function (item) {
        var obj = {
            indexName: $scope.data.indexName,
            channelid: $state.params.channelid,
        };
        // 需要两个参数
        angular.extend(item, obj);
        appQuickSignService.listMapDetail(item, function (success) {
            if (success === 'success') {requestData();}
        });
    };

    /**
     * [fullTextSearch description]全文检索
     *
     * @param   {[type]}  ev  [ev description]按下回车也能提交
     *
     * @return  {[type]}      [return description]
     */
    $scope.fullTextSearch = function (ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            $scope.page.CURRPAGE = 1;
            requestData();
        }
    };

    /**
     * [sign description]直接签发
     *
     * @return  {[type]}  [return description]
     */
    $scope.sign = function () {
        modalDialog.confirmModal('一键快签', '确定快签已选择的稿件吗？', function () {
            var obj = {
                indexName: $scope.data.indexName,
                IsTiming: false,
                channelid: $state.params.channelid,
            };
            $scope.loadingPromise = appQuickSignService.fetchFromBigData(obj, $scope.data.selectedArray).then(
                function (data) {
                    $scope.loadingPromise = appQuickSignService.oneKeyQuickSign(data).then(
                        function () {
                            requestData();
                        }
                    );
                }
            );
        });
    };
    
    /**
     * [timeSign description]定时签发函数
     * @param  {[obj]} item [description]稿件具体信息
     * @return {[type]}      [description]
     */
    $scope.timeSign = function (item) {
        var obj = {
            indexName: $scope.data.indexName,
            IsTiming: true,
            channelid: $state.params.channelid,
        };
        var params1 = {
            isNewDraft: true,
            selectedArray: $scope.data.selectedArray,
            serviceid: 'mlf_appquicksign',
            methodname: 'timeQuickSignDoc',
            isQuickSign: true,
        };
        $scope.loadingPromise = editingCenterService.draftTimeSinged(params1, undefined, true).then(
            function (data) {
                $scope.loadingPromise = appQuickSignService.fetchFromBigData(obj, $scope.data.selectedArray).then(
                    function (item) {
                        data.serviceid = 'mlf_appquicksign';
                        data.ChnlDocIds = trsspliceString.spliceString(item.REPORTS, 'CHNLDOCID', ',');
                        data.ObjectIds = trsspliceString.spliceString(item.REPORTS, 'METADATAID', ',');
                        data.MetaDataIds = trsspliceString.spliceString(item.REPORTS, 'METADATAID', ',');
                        data.selectedArray = item.REPORTS;
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), data, 'POST').then(function (data) {
                            modalDialog.alertType('设置定时快签成功', '', 'success', false, function () {
                                requestData();
                            });
                        });
                    }
                );
            }
        );
    };
}]);
